export default "__VITE_ASSET__Cr9mYT99__"